import React, { useState } from "react";
import { Card, ModalHeader } from "reactstrap";
import Paypal from "../Tip/Paypal";
import StripePayment from "../Tip/StripePayment";
import { updateOrderAction } from "../../store/actions/orderAction";

const PaymentProviders = ({
  paymentMethod,
  renderCards,
  restaurantsDetail,
  darkMode,
  price,
  tipAmountValue,
  uid,
  user,
  paypalFees,
  stripeFees,
  OrderId,
  currency,
  tip,
  tipType,
  dispatch,
  setTipAdded,
  setTipAmountValue,
  setModal,
  setPaymentMethod,
}) => {
  const [paypalSdkValid, setPaypalSdkValid] = useState(true);
  const [stripeSdkValid, setStripeSdkValid] = useState(true);

  if (
    !paymentMethod ||
    !renderCards ||
    !restaurantsDetail ||
    paymentMethod === "cash"
  ) {
    return null;
  }

  return (
    <>
      {restaurantsDetail?.paymentConnections?.paypal &&
        restaurantsDetail?.paypalClientKey &&
        paypalSdkValid && (
          <Card
            className={
              darkMode
                ? "p-3 cart__payment_card-dark"
                : "p-3 cart__payment_card"
            }
            style={{ width: "90%", maxWidth: "500px" }}
          >
            <Paypal
              amount={price}
              tipAmountValue={tipAmountValue}
              forwardFees={paypalFees}
              currency={currency}
              restaurantsDetail={restaurantsDetail}
              getPaypalDetail={(details, finalAmount) => {
                const payload = {
                  OrderId,
                  tip,
                  tipType,
                  totalAmount: finalAmount,
                  customerID: uid,
                  customerName: user?.name,
                  paymentMethod: "Paypal",
                  paymentID: details?.id,
                };
                dispatch(
                  updateOrderAction(payload, () => {
                    setTipAdded(true);
                    setTipAmountValue("");
                  })
                );
                setModal(false);
              }}
              setPayment={setPaymentMethod}
              onSdkError={() => setPaypalSdkValid(false)}
            />
          </Card>
        )}

      {restaurantsDetail?.paymentConnections?.stripe &&
        restaurantsDetail?.paymentConnections?.paypal &&
        paypalSdkValid && <ModalHeader>OR</ModalHeader>}

      {restaurantsDetail?.paymentConnections?.stripe &&
        restaurantsDetail?.stripeClientKey && (
          <>
            <StripePayment
              amount={price}
              tipAmountValue={tipAmountValue}
              orderData={{
                user,
                order: [
                  {
                    currency: restaurantsDetail?.currency || "$",
                    restaurantID:
                      restaurantsDetail?.id ||
                      localStorage.getItem("restaurantId"),
                  },
                ],
              }}
              forwardFees={stripeFees}
              setTipAmountValue={setTipAmountValue}
              setModal={setModal}
              setTipAdded={setTipAdded}
              dispatch={dispatch}
              currency={currency}
              OrderId={OrderId}
              tip={tip}
              tipType={tipType}
              onSdkError={() => setStripeSdkValid(false)}
              paymentMethod={paymentMethod}
            />
          </>
        )}
    </>
  );
};

export default PaymentProviders;
